<template>
  <div class="wrap">
    <h1 class="common-header">{{ $t('350') }}</h1>
    <!-- 内容 -->
    <div class="by-content" v-if="status">
      <el-row>
        <el-col :span="12">
          <span class="label">{{ $t('350') }}</span>
        </el-col>
        <el-col :span="12" class="text-right">
          <el-button type="primary" plain icon="el-icon-menu" @click="changeStatus(false)">{{ $t('881') }}</el-button>
        </el-col>
      </el-row>
      <el-col class="list-con">
        <el-switch
          v-model="invite.openState"
          :active-text="$t('351')"
          :disabled="!$p('menu.settings.invite.edit')"
          @change="handlerSwitchChange"
        ></el-switch>
      </el-col>
      <el-col class="list-con" v-if="invite.openState">
        <p>
          {{ $t('882') }}{{ invite.expire_date }}
          <el-button type="text" icon="el-icon-loading" class="list-btn" @click="handleCode" v-if="$p('menu.settings.invite.edit')">{{
            $t('239')
          }}</el-button>
        </p>
      </el-col>
      <div class="list-con con-wrap" v-if="invite.openState">
        <div class="code-create code">
          <h1 class="by-list-title">{{ $t('354') }}</h1>
          <p>{{ $t('356') }}</p>
          <div class="code-content">
            <!-- 邀请码 -->
            <p>{{ invite.code }}</p>
          </div>
          <!-- 复制团队码 -->
          <el-col class="list-con">
            <el-button @click="copyCode">{{ $t('355') }}</el-button>
          </el-col>
          <p style="line-height: 40px">{{ $t('357') }}</p>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="by-content" v-if="!status">
      <h1 class="by-list-title">
        <el-col :span="12">{{ $t('881') }}</el-col>
        <el-col :span="12" class="text-right">
          <el-button type="primary" plain icon="el-icon-refresh-left" @click="changeStatus(true)">{{
            $t('72')
          }}</el-button>
        </el-col>
      </h1>

      <el-col class="query-form">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item :label="$t('360')">
            <el-select v-model="form.state" :placeholder="$t('360')" clearable>
              <el-option :label="$t('95')" value="0"></el-option>
              <el-option :label="$t('923')" value="1"></el-option>
              <el-option :label="$t('362')" value="2"></el-option>
              <el-option :label="$t('363')" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('922')" class="form-left">
            <staff-search comment="comment" v-model="form.operator_id" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="handleGetPendingList" class="queryBtn">{{ $t('80') }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <div>
        <el-table :data="tableData" border style="width: 100%">
          <!-- 申请人 -->
          <el-table-column prop="staff_name" :label="$t('885')"></el-table-column>
          <!-- 手机号 -->
          <el-table-column prop="phone" :label="$t('825')"></el-table-column>
          <!-- 操作 -->
          <el-table-column fixed="right" :label="$t('832')">
            <template slot-scope="scope">
              <span class="text" v-if="scope.row.state !== '0'">{{ scope.row.state_desc }}</span>
              <template v-if="scope.row.state === '0'">
                <el-button type="text" @click="confirmAgree(scope.row)" v-if="$p('menu.settings.invite.edit')">{{
                  $t('361')
                }}</el-button>
                <el-button type="text" @click="confirmRelod(scope.row)" v-if="$p('menu.settings.invite.edit')">{{
                  $t('362')
                }}</el-button>
                <el-button type="text" @click="confirmShield(scope.row)" v-if="$p('menu.settings.invite.edit')">{{
                  $t('363')
                }}</el-button>
              </template>
              <!-- <span v-else class="text">{{ $t(approvalState.get(scope.row.state), { name: scope.row.operate }) }}</span> -->
              <!-- 员工不可见所有人  -->
              <template v-if="scope.row.state === '3'">
                <el-button type="text" @click="cancelShield(scope.row)">{{ $t('invite_1') }}</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 完善信息 -->
    <Improve ref="improve" v-if="isImprove" @handleGetPendingList="handleGetPendingList" />
  </div>
</template>

<script>
import Improve from './modal/Improve'
// 员工搜索组件
import StaffSearch from '@/components/staff-search'
// 接口地址api
import { getCode, getCreateCode, getPendingList, switchstate, inviteApproval } from 'api/settings'

export default {
  components: {
    Improve,
    StaffSearch
  },
  data() {
    return {
      value: '',
      radio: '',
      status: true,
      form: {},
      tableData: [],
      // 邀请页面数据
      invite: {
        openState: false
      },
      isImprove: false,
      // 申请处理状态  通过 拒绝 屏蔽
      approvalState: new Map([
        ['1', '364'],
        ['2', '365'],
        ['3', '366']
      ])
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // 获取申请人列表
      this.handleGetPendingList()
      this.handlerGetCode()
    },
    // 确认拒绝
    confirmRelod(item) {
      this.$confirm(this.$t('369', { name: item.name }), this.$t('367'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        inviteApproval({ ...item, state: 2 }).then(res => {
          this.$message.success(this.$t('886'))
          this.handleGetPendingList()
        })
      })
    },
    // 确认屏蔽
    confirmShield(item) {
      this.$confirm(this.$t('370'), this.$t('368'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        inviteApproval({ ...item, state: 3 }).then(res => {
          this.$message.success(this.$t('886'))
          this.handleGetPendingList()
        })
      })
    },
    cancelShield(item) {
      // 取消屏蔽
      inviteApproval({ ...item, state: 4 }).then(res => {
        this.$message.success(this.$t('886'))
        this.handleGetPendingList()
      })
    },
    // 切换页面
    changeStatus(val) {
      this.status = val
    },
    // 获取邀请码
    handlerGetCode() {
      getCode().then(res => {
        const data = res.data && res.data.data ? res.data.data : 100
        if (data) {
          this.invite = {
            ...this.invite,
            ...res.data.data
          }
          this.invite.openState = Number(data.state) !== 0
        }
      })
    },
    // 更新邀请码
    handleCode() {
      getCreateCode().then(res => {
        const data = res.data && res.data.data ? res.data.data : 100
        if (data) {
          this.invite = {
            ...this.invite,
            ...res.data.data
          }
          this.invite.openState = Number(data.state) !== 0
        }
      })
    },
    // 复制验证码
    copyCode() {
      var oInput = document.createElement('input')
      oInput.value = this.invite.code
      document.body.appendChild(oInput)
      oInput.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
      oInput.className = 'oInput'
      oInput.style.display = 'none'
      document.body.removeChild(oInput)
      this.$message({
        message: this.$t('888'),
        type: 'success'
      })
    },
    // 申请人列表
    handleGetPendingList() {
      getPendingList(this.form).then(res => {
        this.tableData = res.data.data
      })
    },
    // 同意
    confirmAgree(item) {
      this.isImprove = true
      this.$nextTick(() => {
        // console.log(this.$refs);
        this.$refs.improve.init(item)
      })
    },
    handlerSwitchChange() {
      switchstate()
    }
  }
}
</script>

<style lang="scss" scoped>
.query-form {
  margin: 10px 0;
}
.form-left {
  margin: 0 35px;
}
.code-content {
  font-weight: 600;
  font-size: 38px;
  height: 200px;
  line-height: 200px;
}
.code-create {
  width: 460px;
  height: 400px;
  background-color: #c4c6c7;
}
.code {
  padding: 15px 25px;
}
.list-con {
  margin: 10px 0;
  overflow: hidden;
}
.con-wrap {
  width: 400px;
}
.list-btn {
  font-size: 14px;
  margin-left: 20px;
}
.text {
  margin-right: 10px;
}
.by-content {
  min-height: 100%;
  padding-bottom: 40px;
  // height: calc(100% - 60px)
}
.radio-wrap {
  line-height: 60px;
}
.by-list-title {
  line-height: 1;
  height: 18px;
  color: $menuBg;
  font-weight: 600;
}
/deep/ .el-input {
  height: 32px;
  input {
    height: 32px;
  }
}
.add-staff {
  float: right;
  margin-bottom: 10px;
  color: $ls;
}
.sel-auth {
  margin: 0 20px;
}
.table-wrap {
  margin-top: 20px;
}
.text-right {
  text-align: right;
  .el-button {
    margin: 0 23px;
    &:nth-child(2) {
      margin-right: 0;
    }
  }
}
</style>
